// 用户相关API
import request from '@/utils/request'

/**
 * 获取用户信息
 * @returns {Promise}
 */
export function getMyUserCenter() {
  return request({
    url: '/user/userExtend/myUserCenter',
    method: 'get'
  })
}
// 编辑个人信息
export function setSaveUserInfo(data) {
  return request({
    url: '/user/userExtend/saveUserInfo',
    method: 'post',
    data
  })
}
// 编辑资料
export function setDatum(data) {
  return request({
    url: '/user/userExtend/setDatum',
    method: 'post',
    data
  })
}
// 声音标签列表
export function characterList() {
  return request({
    url: '/tag/characterTag/characterList',
    method: 'get'
  })
}
// 游戏列表
export function gameList() {
  return request({
    url: '/game/game/gameList',
    method: 'get'
  })
}
// 大神认证
export function userCertification(data) {
  return request({
    url: '/user/userCertification/userCertification',
    method: 'post',
    data
  })
}
// 大神认证详情
export function userCertificationDetail(data) {
  return request({
    url: '/user/userCertification/beaterDetail',
    method: 'post',
    data
  })
}
// 我允许选择的游戏列表
export function certificationGameList(data) {
  return request({
    url: '/user/userCertification/certificationGameList',
    method: 'post',
    data
  })
}
// 各种协议
export function getAgreement(data) {
  return request({
    url: '/config/getAgreement',
    method: 'get',
    params: data
  })
}

// 其他用户中心
export function otherUserCenter(data) {
  return request({
    url: '/user/userExtend/otherUserCenter',
    method: 'get',
    params: data
  })
}
// 添加关注
export function addAttention(data) {
  return request({
    url: '/user/userFollowersFans/addAttention',
    method: 'post',
    data
  })
}
// 取消关注
export function cancelAttention(data) {
  return request({
    url: '/user/userFollowersFans/cancelAttention',
    method: 'post',
    data
  })
}
// 其他用户技能列表
export function otherSkillList(data) {
  return request({
    url: '/game/gameSkill/otherSkillList',
    method: 'get',
    params: data
  })
}
// 其他用户图片列表
export function otherImageList(data) {
  return request({
    url: '/user/userImage/imageListBy',
    method: 'get',
    params: data
  })
}
// 礼物墙
export function getDonateGoodslist(data) {
  return request({
    url: '/goods/goodsDonate/donateGoodslist',
    method: 'get',
    params: data
  })
}
// 点亮礼物列表
export function giftLightList(data) {
  return request({
    url: '/goods/goods/giftLightList',
    method: 'get',
    params: data
  })
}
// 礼物列表
export function getGiftList(data) {
  return request({
    url: '/goods/goods/giftList',
    method: 'get',
    params: data
  })
}
// 送礼物
export function giveGift(data) {
  return request({
    url: '/goods/goods/giveGift',
    method: 'get',
    params: data
  })
}
// 送礼数量
export function getGiftSendNum(data) {
  return request({
    url: '/goods/goodsSendNum/list',
    method: 'get',
    params: data
  })
}
// 技能详情
export function getSkillDetail(data) {
  return request({
    url: '/game/gameSkill/detail',
    method: 'get',
    params: data
  })
}
// 我的技能列表
export function getMySkillList(data) {
  return request({
    url: '/game/gameSkill/mySkillList',
    method: 'get',
    params: data
  })
}

// 添加技能
export function saveSkillApply(data) {
  return request({
    url: '/game/gameSkill/saveSkillApply',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
// 编辑技能申请
export function editSkillApply(data) {
  return request({
    url: '/game/gameSkill/editSkillApply',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
// 批量添加用户照片墙
export function addAll(data) {
  return request({
    url: '/user/userImage/addAll',
    method: 'post',
    data
  })
}
// 删除用户照片墙
export function removeImage(data) {
  return request({
    url: '/user/userImage/removeImage',
    method: 'post',
    data
  })
}

// 指定用户的照片墙
export function imageListBy(data) {
  return request({
    url: '/user/userImage/imageListBy',
    method: 'get',
    params: data
  })
}
// 技能类型
export function gameSkillType(data) {
  return request({
    url: '/game/gameSkillType/list',
    method: 'get',
    params: data
  })
}
// 开启-关闭技能
export function setStatus(data) {
  return request({
    url: '/game/gameSkill/setStatus',
    method: 'get',
    params: data
  })
}
// 开启-关闭系统接单
export function setIsSystem(data) {
  return request({
    url: '/game/gameSkill/setIsSystem',
    method: 'get',
    params: data
  })
}
// 举报原因
export function queryReportReason(data) {
  return request({
    url: '/report/queryReportReason',
    method: 'get',
    params: data
  })
}
// 举报
export function report(data) {
  return request({
    url: '/report/report',
    method: 'post',
    data
  })
}
// 拉黑的用户分页列表
export function shieldingList(data) {
  return request({
    url: '/user/userShielding/shieldingList',
    method: 'get',
    params: data
  })
}

// 添加拉黑
export function addShielding(data) {
  return request({
    url: '/user/userShielding/addShielding',
    method: 'post',
    data
  })
}
// 解除拉黑
export function remShielding(data) {
  return request({
    url: '/user/userShielding/remShielding',
    method: 'post',
    data
  })
}


// 礼物清单（送礼的）
export function giftInventoryList(data) {
  return request({
    url: '/goods/goodsDonate/giftInventoryList',
    method: 'get',
    params: data
  })
}

// 金币流水
export function diamondList(data) {
  return request({
    url: '/bill/diamondBill/diamondList',
    method: 'get',
    params: data
  })
}
// 钻石流水
export function integralList(data) {
  return request({
    url: '/bill/pointBill/integralList',
    method: 'get',
    params: data
  })
}
// 钻石兑换金币
export function pointExchange(data) {
  return request({
    url: '/bill/pointBill/pointExchange',
    method: 'get',
    params: data
  })
}
// 我的账户信息
export function myAccount(data) {
  return request({
    url: '/user/userAccount/myAccount',
    method: 'get',
    params: data
  })
}
/** 银行列表（zb_bank） */
export function bankList(data) {
  return request({
    url: '/bank/bank/list',
    method: 'get',
    params: data
  })
}
// 会员等级信息
export function gradeInfo(data) {
  return request({
    url: '/member/memberGrade/gradeInfo',
    method: 'get',
    params: data
  })
}
// 我的足迹记录
export function myTwoVisitList(data) {
  return request({
    url: '/user/userVisitLog/myTwoVisitList',
    method: 'get',
    params: data
  })
}
// 清空足迹
export function clearVisit(data) {
  return request({
    url: '/user/userVisitLog/clearVisit',
    method: 'get',
    params: data
  })
}
// 我的访客记录
export function myVisitList(data) {
  return request({
    url: '/user/userVisitLog/myVisitList',
    method: 'get',
    params: data
  })
}
// 注销类型列表查询
export function cancelTypeList(data) {
  return request({
    url: '/cancel/cancel/list',
    method: 'get',
    params: data
  })
}
// 注销申请
export function cancelApply(data) {
  return request({
    url: '/user/cancelApply',
    method: 'post',
    data
  })
}
// 查询用户注销申请状态
export function getCancelApplyStatus(data) {
  return request({
    url: '/user/getCancelApplyStatus',
    method: 'get',
    params: data
  })
}
// 我的装扮信息
export function myDressList(data) {
  return request({
    url: '/goods/goods/myDressList',
    method: 'get',
    params: data
  })
}
// 穿戴装扮
export function wearGoods(data) {
  return request({
    url: '/goods/goods/wearGoods',
    method: 'get',
    params: data
  })
}
// 取消穿戴
export function unWearGoods(data) {
  return request({
    url: '/goods/goods/unWearGoods',
    method: 'get',
    params: data
  })
}
// 绑定支付宝微信账号
export function bindUserAccount(data) {
  return request({
    url: '/user/userAccount/bindUserAccount',
    method: 'post',
    data
  })
}
// 绑定银行卡
export function bindUserBank(data) {
  return request({
    url: '/user/userAccount/bindUserBank',
    method: 'post',
    data
  })
}
// 判断用户是否绑定微信
export function getUserBindOrNot(data) {
  return request({
    url: '/user/getUserBindOrNot',
    method: 'get',
    params: data
  })
}
// 解除绑定微信账号
export function unBindWxOpenId(data) {
  return request({
    url: '/user/userAccount/unBindWxOpenId',
    method: 'post',
    data
  })
}
// 查询绑定状态
export function getWxOpenId(data) {
  return request({
    url: '/user/userAccount/getWxOpenId',
    method: 'post',
    data
  })
}
// 根据code获取微信唯一的openId
export function getOpenIdByCode(data) {
  return request({
    url: '/user/getOpenIdByCode',
    method: 'post',
    data
  })
}
// 绑定微信账号
export function bindWxOpenId(data) {
  return request({
    url: '/user/userAccount/bindWxOpenId',
    method: 'post',
    data
  })
}
